import { useState, useEffect } from 'react';
import { BXPTimeConditionsTable } from 'components/tables/BXPTimeConditionsTable';
import {
  fetchBXPTimeConditions,
  BXPTimeCondition
} from 'services/hvaservicecampaign.service';

const BXPTimeConditionList: React.FC = () => {
  const [timeConditions, setTimeConditions] = useState<BXPTimeCondition[]>([]);
  const loadTimeConditions = async (): Promise<void> => {
    try {
      const fetchedTimeConditions = await fetchBXPTimeConditions();
      setTimeConditions(fetchedTimeConditions);
    } catch (error) {
      console.error('Error loading time conditions:', error);
    }
  };

  useEffect(() => {
    loadTimeConditions();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <BXPTimeConditionsTable
          timeConditions={timeConditions}
          onTimeConditionsChange={loadTimeConditions}
        />
      </div>
    </div>
  );
};

export default BXPTimeConditionList;
